import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";

export class PendingPayments extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      visitid: "",
      DataLoaded: false,
    };
  }

  // handleRowClick(patient) {

  // $('.patientDetails').show()
  // $('.startTreatment').attr('id',patient.visitid)
  // var details = patient.Name+' ('+patient.Age+')- '+patient.Nationality
  // $('.patientName').text(details)
  // var visitId = (patient.visitid).split('_')
  // var serialNumber = visitId[1]
  // var visitNumber = visitId[2]

  // $('.NumberOfVisit').text(visitNumber)
  // $('.SerialNumber').text(serialNumber)

  // // {
  // //     label: "Number of Visit",
  // //     field: "EvolutionAndTreatment",
  // //     sort: "asc",
  // //     width: 50
  // // },
  // // {
  // //     label: "Serial Number",
  // //     field: "EvolutionAndTreatment",
  // //     sort: "asc",
  // //     width: 50
  // // },

  // }

  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
    };
    console.log(localStorage.getItem("accessToken"));
    axios
      .get(this.url + "/billing/pendingpayments", { headers: headers })
      .then((res) => {
        console.log(res.data);
        for (var i = 0; i < res.data.length; i++) {
          console.log(res.data[i]);

          var number = i + 1;
          // console.log()
          var split = res.data[i]["timeofopen"].split(" ");
          var date = split[0];
          var time = split[1];

          let tableinit = res.data;

          // console.log(typeof(table))
          let object = {};
          for (let i = 0; i < tableinit.length; i++) {
            delete tableinit[i]._id;
            delete tableinit[i].timeOfRegistration;
            tableinit[i].clickEvent = () => this.handleRowClick(tableinit[i]);
          }
          // table = JSON.stringify(table);

          var table = Object.assign(tableinit);

          // alert(table)
          this.TableData = table;
          // console.log(this.TableData);
          this.setState({
            DataLoaded: true,
          });

          // var searchRow = '<tr><td>'+number+'</td> <td>'+res.data[i]['Name']+'</td><td>'+res.data[i]['Age']+'</td><td>'+res.data[i]['Profession']+'</td><td>'+res.data[i]['MaritalStatus']+'</td><td>'+res.data[i]['Address']+'</td><td>'+res.data[i]['Tel ']+'</td><td>'+res.data[i]['Nationality']+'</td><td>'+date+'</td><td>'+time+'</td><td>'+visitNumber+'</td><td>'+serialNumber+'</td><td></td><td></td><td><a className="btn btn-primary startTreatment" id="'+res.data[i]['visitid']+'">Start Treatment</a></td></tr>'
          // $('.searchClass').append(searchRow)
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Complications, PregnancyDate, EvolutionAndTreatment } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "total_paid",
          field: "total_paid",
          sort: "asc",
          width: 50,
        },
        {
          label: "total_pending",
          field: "total_pending",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />

        <main>
          <div className="container p-2">
            <form>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>
                <MDBDataTable striped bordered data={tabledata} />
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PendingPayments;
